import React, { FC } from 'react';
import s from './TemplatesPageHeading.scss';

interface TemplatesPageHeadingProps {
  heading: string;
  subHeading?: string;
}

export const TemplatesPageHeading: FC<TemplatesPageHeadingProps> = ({
  heading,
  subHeading,
}) => {
  return (
    <div className={s.headingWrapper}>
      <h1 className={s.heading}>{heading}</h1>
      {subHeading && <h2 className={s.subHeading}>{subHeading}</h2>}
    </div>
  );
};
